import { combineReducers } from 'redux';

import { ACTION_ADD_CAMPAIGNS_STATS } from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_CAMPAIGNS_STATS:
      return { ...state, ...action.payload.campaignsStats };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
